/* eslint-disable  max-len */
const regex = {
  macAddress: /^([0-9A-Fa-f]{2}:){5}([0-9A-Fa-f]{2})$/, // https://stackoverflow.com/a/4260512
  ipv4: /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
  email:
    /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:\w(?:[\w-]*\w)?\.)+\w(?:.*\w)?(?<!.{250,})$/,
  name: /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*\.?$/,
  phoneNumber:
    /^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d*)\)?)[-. \\/]?)?((?:\(?\d{1,}\)?[-. \\/]?)+)(?:[-. \\/]?(?:#|ext\.?|extension|x)[-. \\/]?(\d+))?$/,
  alphaNumeric: /^[a-zA-Z0-9 ]*$/,
  password: /^(?=(.*[a-z]){1,})(?=(.*[A-Z]){1,})(?=(.*[\d]){1,})(?=(.*[\W_]){1,}).{10,}$/,
  url: /^(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b(\/[-a-zA-Z0-9@:%_+.~#?&//=]*\w)?$/,
  deviceName: /^[^"'\n\\]+$/,
}

export default regex
